var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconNp = function SvgIconNp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M23.93 13.304 10.77.062Q9.877.154 9.03.37C3.839 1.692 0 12 0 12s16.8 11.242 18.717 9.945q.575-.39 1.1-.841l-7.799-7.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M20.87 12 9.199.33C3.923 1.59 0 6.336 0 12c0 6.627 5.373 12 12 12 2.514 0 4.847-.774 6.775-2.095L8.87 12z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.413 17.717-1.466-.689.78-1.42-1.591.305-.202-1.608-1.108 1.183-1.109-1.183-.201 1.608-1.592-.304.78 1.419-1.465.69 1.466.689-.78 1.419 1.59-.304.202 1.607 1.109-1.182 1.108 1.182.202-1.607 1.591.304-.78-1.42zM10.434 6.655l-1.066-.501.568-1.033-1.158.222-.146-1.17-.806.86-.807-.86-.146 1.17-1.158-.222.568 1.033-1.066.5 2.609.523z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.957 6.655a3.13 3.13 0 0 1-6.26 0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconNp;